import React from "react";
import * as actions from './actions';
export default function FilterCategory({ eleRef , eleThis}) {
    const items = [];

    const sublistul = [];
    const fiterData = [];
    const subFilterData = [];

    for (const [index, value] of eleRef.entries()) {
        var sublist = [];

        items.push(
            `sub_${value.filterTitle}`
        );
        for(const [index, result] of value.values.entries()){
            sublist.push(<div key={index} option={result.key}><span className="checkbox1" data-icon-font="z"></span><span className="checkbox2" data-icon-font="A"></span>{result.key}</div>);
        }
        sublistul.push(<ul key={`a_${index}`} className={`sub${value.filterTitle.toLowerCase()} subcategorieslist`} id={`sub${value.filterTitle.toLowerCase()}`} hidden>
            <amp-selector multiple="" name={`${value.filterTitle.toLowerCase()}-selector[]`} id={`my${value.filterTitle.toLowerCase()}filter`}
                    layout="container"
                    // className="radio-selector"
                    >
                {sublist}
            </amp-selector>
        </ul>);
    }
    for (const [index, value] of eleRef.entries()) {
        for (const [index1, value1] of eleRef.entries()) {
            let var1=`sub_${value.filterTitle}`;
            if(var1!=items[index1]){
                subFilterData.push(
                    `${items[index1]}.hide`
                );
            }
        }
    }
    
    return (
        <div className="filter-overlay overlay"  id="filter_popup_overlay" hidden>
            <div className="filter-popup filter_popups">
                <div className="filter_by">
                    <span className="M18_42">Filter By</span>
                    <span className="right icon" data-icon-font="C" tabIndex="0" role="button" on="tap:filter_popup_overlay.hide,filter_popup_overlay.hide,applyFilter.clear, mygenderfilter.clear, myreligionfilter.clear, myoriginfilter.clear, mynumerologyfilter.clear, myrashifilter.clear, mynakshatrafilter.clear, mystartwithfilter.clear, mygodfilter.clear"></span>
                </div>
                <div className="catg_filter">
                    <form className="sample-form" method="post" name="applyFilter" id="applyFilter" action-xhr={`${global.hosturl}parenting/BabynamesAmp/applyAllfilters`} custom-validation-reporting="show-first-on-submit">
                    <ul className="left">
                        <li className="category_list">
                        <ul className="left categorieslist">
                            {eleRef && eleRef.length>0 && eleRef.map((value, index)=>(
                                <li key={index} className={value.filterTitle} role="button" tabIndex={index} id={value.filterTitle} on={`tap:subgender.hide,subreligion.hide,suborigin.hide,subnumerology.hide,subrashi.hide,subnakshatra.hide,substartwith.hide,subgod.hide, ${`sub${value.filterTitle.toLowerCase()}.show`}`}>
                                    <span className="catname R14_42">{value.filterTitle}</span>
                                    <div className="subcatCount"></div>
                                </li>
                            ))}
                        </ul>
                        </li>
                        <li className="subcategory_list">
                           {sublistul}
                        </li>
                    </ul>
                        <div className="cancel_apply_btn cancel_apply_btn">
                            <div className="error-msg" submit-error="">
                                <template type="amp-mustache">
                                Error!, please try again.
                                </template>
                            </div>
                            <div className="" id="toast-msg" hidden>
                                Select at least one filter
                            </div>
                            <div className="submit_btns">
                                <button type="submit" name="key" value="filterCnl" role="button" tabIndex="0" className="M14_9e cancelfilter curs_pointer" on="tap:filter_popup_overlay.hide,applyFilter.clear, mygenderfilter.clear, myreligionfilter.clear, myoriginfilter.clear, mynumerologyfilter.clear, myrashifilter.clear, mynakshatrafilter.clear, mystartwithfilter.clear, mygodfilter.clear">CLEAR ALL</button>

                                <div className="applyfilter">
                                <button type="submit" tabIndex="0" role="button" className="M14_pink dev_listfilter curs_pointer" id="dev_fl_tr" data-vars-event-category="Baby Names - Search by Baby Names using Filters" data-vars-event-action="More Filters - Apply" data-vars-event-label="MORE FILTER ">APPLY</button>
                                </div>
                            </div>
                            <input type="hidden" id="cubcatstrr" value=" " />
                        </div>
                    </form>
                </div>
                
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// src/shared/baby-names-amp/FilterCategory.js